import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// بيرجّع السكرول لفوق تلقائياً كل ما الـ route يتغيّر
const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTopOnRouteChange;
